/* Author: Vaishnavi
Date: 27/11/2019
Issue NO:-
Description: Spacing issues fixed as per design guidelines
*/
/* Author: Srinivas Pendker
Date: 04/12/2019
Issue NO:-
Description: while changing the selectcriteria in the dropdown
Search_string: selectcriteria
*/
/* Author: Srinivas Pendker
Date: 06/12/2019
Issue NO:-PL-1892
Description: Probation Settings data not showing on fetching
*/
/* Author: Srinivas Pendker
Date: 06/12/2019
Issue NO:-PL-2256
Description: Change in Criteria issue
*/
/* Author: Vinod
Date: 27/01/2020
Issue NO: PL_2525
Description: The settings are saved in DB but not reflecting in UI.
*/
/*
Author: Shivakumar
Date: 10/03/2020
Issue Description: [Probation Settings] Values are not displaying in the fields when clicked on cancel button.
search_string: PL_2648
*/

<template>
  <div>
    <div class="uploadMethoRadio">
      <tl-radio
        name="uploadMethod"
        id="bulkUpload"
        label="Bulk Upload"
        value="bulkUpload"
        :checked="uploadMethod"
        v-model="uploadMethod"
      />
      <tl-radio
        name="uploadMethod"
        id="manualUpload"
        label="Manual"
        value="manualUpload"
        :checked="uploadMethod"
        v-model="uploadMethod"
      />
    </div>
    <div v-if="uploadMethod == 'bulkUpload'">
      <div class="download-btn">
        <download-button></download-button>
      </div>
      <div class="upload margintop-20">
        <upload-file />
      </div>
    </div>
    <div v-else>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="margin-t-l">
        <!--start code of select criteria -->
        <tl-select
          label="Select Criteria *"
          labelText="name"
          :options="criteriaList"
          :placeholder="'Select'"
          v-model="criteriaType"
          name="criteria"
          @change="changeCriteria($event)"
          v-validate="'required'"
          :classname="errors.has('criteria')"
          :errormsg="errors.first('criteria')"
        ></tl-select>
      </div>
      <br />
      <!-- End of code of select criteria -->
      <tl-checkbox
        class="margin-t-s"
        name="sameforall"
        v-show="criteriaType"
        :label="`Same for all ${criteriaType}`"
        v-model="formData.same_for_all"
        ref="isSameForAll"
        :data-vv-as="`same for all ${criteriaType}`"
      />
      <!-- @change="changeHandler" PL_2525 -->

      <div v-if="formData.same_for_all">
        <div class="margintop-24 uploadMethoRadio">
          <tl-radio name="probType" label="Days" id="day" value="days" v-model="probType" />
          <tl-radio name="probType" label="Months" id="month" value="months" v-model="probType" />
        </div>
        <div class="margin-t-m">
          <txt
            autofocus="autofocus"
            name="probationValue"
            type="text"
            v-numeric-only
            v-model="formData.probation_value"
            data-vv-as="duration"
            v-validate="'required_if:isSameForAll,true'"
            :classname="errors.has('probationValue')"
            :errormsg="errors.first('probationValue')"
          />
        </div>
      </div>
      <br />
      <div v-show="!formData.same_for_all">
        <div class="empl-fbp-table margintop-24">
          <table class="particular-table">
            <thead>
              <tr>
                <th>{{criteriaType}}</th>
                <th>Days/Month</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr class="record-row" v-for="(item, index) of tableDataList" :key="index">
                <td>{{ item.name }}</td>
                <td>
                  <tl-select
                    labelText="name"
                    :name="'days_month'+index"
                    :options="probationTypes"
                    v-model="item.unit"
                    @change="(val)=> {item.unit=val;changeSameForAllValue(val,index)}"
                    data-vv-as="Days/Month"
                    v-validate="'required_if:isSameForAll,false'"
                    :classname="errors.has('days_month'+index)"
                    :errormsg="errors.first('days_month'+index)"
                  />
                </td>
                <td>
                  <txt
                    autofocus="autofocus"
                    :name="'value'+index"
                    type="text"
                    v-numeric-only
                    v-model="item.value"
                    placeholder="Enter Probation Period"
                    data-vv-as="Value"
                    v-validate="'required_if:isSameForAll,false'"
                    :classname="errors.has('value'+index)"
                    :errormsg="errors.first('value'+index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <pop-up-message
      v-if="showChangedPopup"
      :message="'The data already set will be deleted on changing the criteria. Are you sure you wish to change the crietria ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Change'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="changeEvent()">Change</button>
        </div>
      </template>
    </pop-up-message>
    <footer>
      <bottom-action-container>
        <btn-skip @navClicked="$emit('skip')"></btn-skip>
        <btn-grp slot="end">
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="saveProbation()"></btn>
        </btn-grp>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { criteriaObj, probationObj } from "../../../../../../apis/constants.js";
export default {
  computed: {
    ...mapState({
      locationsList: state => state.onboard.locations.data,
      designationsList: state => state.onboard.designations.entityWiseData,
      salaryList: state => state.onboard.salary_grades.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    }
  },
  mounted() {
    this.uploadMethod = "manualUpload";
    this.toast = false;
    this.fetchProbationSettings();
  },
  activated() {
    this.uploadMethod = "manualUpload";
    this.toast = false;
  },
  data() {
    return {
      formData: {
        same_for_all: false,
        probation_value: null
      },
      recordObj: null,
      probType: "days",
      popupMessage: "",
      errmsg: "",
      toast: false,
      popupType: "ConfirmDelete",
      criteriaType: "",
      columnNames: [
        {
          label: "Criteria",
          key: "criteria"
        },
        {
          label: "Days/Months",
          key: "criteriatype"
        },
        {
          label: "Value",
          key: "value"
        }
      ],
      tableDataList: [],
      data: [],
      showSuccessMsg: false,
      uploadMethod: "manualUpload",
      criteriaList: criteriaObj.probationCriteria,
      probationTypes: probationObj.probationTypes,
      probationValue: "",
      tempArray: [],
      showChangedPopup: false,
      criteriaPrevSelected: "",
      criteriaAfterSelected: "",
      probationSettingsData: {} // PL_2525
    };
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/locations/fetchAll",
      act_fetch_designation: "onboard/designations/fetchAll",
      act_fetch_grades: "onboard/salary_grades/fetchAll",
      act_fetch_probation: "onboard/probationPeriod/fetchAll",
      act_create: "onboard/probationPeriod/create",
      act_update: "onboard/probationPeriod/update"
    }),

    changeSameForAllValue(event, index) {
      this.$validator.reset();
    },
    /** On Select Criteria drop down value click */
    async changeCriteria(event) {
      try {
        if (this.criteriaType == "") {
          this.criteriaPrevSelected = this.criteriaType;
          this.criteriaType = event;
          await this.fetchAll(this.criteriaType);
        } else if (this.criteriaType != event) {
          this.criteriaPrevSelected = this.criteriaType;
          this.showChangedPopup = true;
          this.criteriaAfterSelected = event;
          await this.reset();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of Change button in conform popup for Select Criteria */
    async changeEvent() {
      try {
        this.showChangedPopup = false;
        this.probType = "days";
        this.formData.probation_value = null;
        /** PL_2648 */
        this.criteriaType = this.criteriaAfterSelected;
        let currentCriteriaType =
          this.recordObj && this.recordObj.criteria
            ? this.recordObj.criteria.type == "LOCATION"
              ? "Location"
              : this.recordObj.criteria.type == "DESIGNATION"
              ? "Designation"
              : this.recordObj.criteria.type == "GRADE"
              ? "Grade"
              : null
            : null;
        if (currentCriteriaType == this.criteriaType) {
          this.fetchProbationSettings();
        } else {
          await this.fetchAll(this.criteriaType);
        }
        /** PL_2648 */
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of Cancel button in confirm popup for Select Criteria */
    async cancelEvent() {
      try {
        this.showChangedPopup = false;
        /** PL_2648 */
        this.criteriaType = this.criteriaPrevSelected;
        if (
          this.recordObj &&
          this.criteriaType.toUpperCase() ==
            this.recordObj.criteria.type.toUpperCase()
        ) {
          this.fetchProbationSettings();
        } else {
          await this.reset();
        }
        /** PL_2648 */
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To reset the form data with the initial existing data */
    async reset() {
      try {
        if (this.showChangedPopup == true) {
          this.criteriaType = this.criteriaAfterSelected;
          await this.fetchAll(this.criteriaType);
        } else {
          this.criteriaType = this.criteriaPrevSelected;
          await this.fetchAll(this.criteriaType);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation to previous screen */
    previous() {
      this.$emit("nextStep", 3);
      this.$validator.reset();
    },

    /** To fetch data from server and to populate the form data */
    // Start PL_2525
    async fetchProbationSettings() {
      try {
        let res = await this.act_fetch_probation(this.le_id);
        if (res.data.status && res.data.payload.data) {
          this.recordObj = res.data.payload.data;
          let obj = res.data.payload.data;
          this.probationSettingsData = res.data.payload.data;
          this.criteriaType =
            obj.criteria.type == "LOCATION"
              ? "Location"
              : obj.criteria.type == "DESIGNATION"
              ? "Designation"
              : obj.criteria.type == "GRADE"
              ? "Grade"
              : null;
          await this.fetchAll(this.criteriaType);
          this.formData.same_for_all = obj.same_for_all;
          if (this.formData.same_for_all) {
            this.formData.probation_value = obj.value;
            this.probType = obj.unit;
          } else {
            let tempArray = [];
            Object.assign(tempArray, this.tableDataList);
            if (obj.criteria) {
              if (obj.criteria.values) {
                obj.criteria.values.forEach(element => {
                  tempArray.forEach(item => {
                    if (element.id == item.id) {
                      item.unit =
                        element.unit == "days"
                          ? this.probationTypes[0]
                          : this.probationTypes[1];
                      item.value = element.value;
                    }
                  });
                });
                this.tableDataList = tempArray;
              }
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch all the sub-criteria values for respective criteria */
    async fetchAll(criteriaType) {
      try {
        let res = {};
        if (criteriaType == "LOCATION" || criteriaType == "Location") {
          res = await this.act_fetch(this.le_id);
          this.tableDataList = res.data.payload.data.map(item => {
            return { id: item.id, name: item.name, unit: "", value: "" };
          });
        }
        if (criteriaType == "DESIGNATION" || criteriaType == "Designation") {
          res = await this.act_fetch_designation(this.le_id);
          this.tableDataList = this.designationsList[this.le_id].map(item => {
            return { id: item.id, name: item.name, unit: "", value: "" };
          });
        }
        if (criteriaType == "GRADE" || criteriaType == "Grade") {
          res = await this.act_fetch_grades(this.le_id);
          this.tableDataList = this.salaryList[this.le_id].map(item => {
            return { id: item.id, name: item.name, unit: "", value: "" };
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to submit the form data to server  */
    async performAction() {
      try {
        var criteriaenum = "";
        var probTypeEnum = "";
        let obj = {};
        if (
          this.criteriaType == "LOCATION" ||
          this.criteriaType == "Location"
        ) {
          criteriaenum = "LOCATION";
        }
        if (this.criteriaType == "GRADE" || this.criteriaType == "Grade") {
          criteriaenum = "GRADE";
        }
        if (
          this.criteriaType == "DESIGNATION" ||
          this.criteriaType == "Designation"
        ) {
          criteriaenum = "DESIGNATION";
        }
        this.$root._data.isSaving = true;

        obj = {
          data: {
            le_id: this.le_id,
            id: this.probationSettingsData.id,
            probabation_setting_criteria: criteriaenum,
            same_for_all: this.formData.same_for_all,

            unit: this.formData.same_for_all ? this.probType : null,
            value: this.formData.same_for_all
              ? Number(this.formData.probation_value)
              : null,
            criteria: this.formData.same_for_all
              ? {
                  type: criteriaenum,
                  values: []
                }
              : {
                  type: criteriaenum,
                  values: this.tableDataList.map(item => {
                    return {
                      id: item.id,
                      unit: item.unit ? item.unit.id : null,
                      value: Number(item.value)
                    };
                  })
                }
          }
        };

        let res = null;
        if (!this.probationSettingsData.id) {
          res = await this.act_create(obj);
        } else {
          res = await this.act_update(obj);
        }

        if (res.data.status) {
          this.popupMessage = res.data.message;
          setTimeout(() => {
            this.showSuccessMsg = true;
            this.$root._data.isSaving = false;
            this.hideSuccessMsg();
          }, 500);
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /** Function to validate the form data */
    saveProbation() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction();
          } else {
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
    // End PL_2525
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/_variables.scss";
.uploadMethoRadio {
  display: flex;
  margin-top: 32px;
}
.download-btn {
  margin-top: 2%;
}
.custom-width {
  width: 300px;
}
.custom-margin {
  margin-top: 20px;
}
.prob_fields {
  display: flex;
}
.probField {
  margin-right: 30px;
}
.probPeriod {
  margin-right: 145px;
}
.empl-fbp-table {
  .particular-table {
    background-color: #f9f9f9;
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      padding: 10px;
    }
    thead {
      th {
        border-bottom: 2px solid #34c0be;
      }
    }
    .tableInput {
      width: 50%;
    }
  }
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
  border: none;
  background: none;
}
.customwidth {
  width: 88px;
}
.record-row {
  height: 54px;
  border-bottom: 1px solid #d8d8d8;
  //   text-align: center;
  &:nth-child(odd) {
    background-color: #ffffff;
  }
  &.selectedRecord {
    background-color: #e9f9f8;
    opacity: 0.9;
  }

  td {
    padding: 6px 8px;
    color: #646464;
    .tl-checkbox {
      text-align: center;
    }
  }
  .actions {
    width: 10%;
    padding: 10px;
  }
  .row-item {
    p {
      width: 100%;
      margin-bottom: 0px;
    }
    padding: 6px 8px;
    //   width: 10%;
  }
  .action-img {
    display: inline-block; // inline-block will set all images in row so i changed here
    cursor: pointer;
    opacity: 0.1;
  }

  &:hover {
    .action-img {
      opacity: 1;
    }
  }
}
</style>
